import React, { useContext, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import { ButtonAddRoute, TextAddRoute, TextTitlePage } from "./styles";
import {
  Header,
  Container,
  Content,
  TextField,
  Button,
  CustomDropDown,
  ContentButton,
} from "../../../../components";
import RouteContext from "../../../../context/route";
import ClientContext from "../../../../context/client";
// import { FormProvider, useForm } from "react-hook-form";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";

function NewRouteAdmin() {
  const navigation = useNavigation();
  const { setNewRoute } = useContext(RouteContext);
  const { clients, clientsSelects } = useContext(ClientContext);
  const [recipientOpen, setRecipientOpen] = useState(false);
  const [recipientValue, setRecipientValue] = useState(0);
  const [noteNumber, setNoteNumber] = useState('');

  async function handleSubmit() {
    const nameRecipient = clientsSelects.filter(item=> item.value === recipientValue);
    setNewRoute((prevState: any) => ({
      ...prevState,
      routes: [...prevState.routes, {
        recipient: recipientValue,
        recipientName: nameRecipient[0].label,
        noteNumber: noteNumber
      }]
    }));
    navigation.goBack();
  }

  return (
    <Container>
      <Header name="Bruno Morais" type="simple" title="Motorista" />
      <Content>
        <TextTitlePage>Dados da nova rota</TextTitlePage>
        <View style={{zIndex: 3}}>
          <CustomDropDown
            open={recipientOpen}
            value={recipientValue}
            items={clientsSelects}
            setOpen={setRecipientOpen}
            setValue={setRecipientValue}
            placeholder="Destinatário"
            setItems={setRecipientValue}
          />
        </View>
        <TextField
          label='Número da nota / número do pedido'
          placeholder='Número da nota / número do pedido'
          value={noteNumber}
          keyboardType="number-pad"
          returnKeyType="done"
          onChangeText={(text: string) => setNoteNumber(text)}
        />
      </Content>
      <ContentButton>
        <Button
          title="Salvar"
          onPress={handleSubmit}
          // disabled={clientValue > 0 ? false : true || recipientValue > 0 ? false : true }
        />
      </ContentButton>
    </Container>
  );
}

export default NewRouteAdmin;
